module.exports = __webpack_public_path__ + "static/media/tutorial-1.7b2ee994.jpg";